export const stringify = <T>(value: T): string => {
  if (value === undefined) {
    return 'undefined';
  }
  return JSON.stringify(value);
};

export const parse = <T>(text: string): T => {
  if (text === 'undefined') {
    return (undefined as unknown) as T;
  }
  return JSON.parse(text);
};
